// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DnDFieldsConfig.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * DnDFieldsConfig
 */

import CONSTANTS from 'logic/data/Izenda.ReportDesignerConstants';
import { get, isNil } from 'lodash/fp';
import { resetStyleItem, hover } from 'share/utils/Izenda.FilterDnDUtils';

let position = { value: null };

export default {
  sourceOptions: {
    beginDrag(props: any) {
      const {
        itemData,
        itemData: { id, visible, filterable, isParameter },
        dataObject
      } = props;

      const item = {
        querySourceFieldId: id,
        visible: visible,
        filterable: filterable,
        isParameter: isParameter,
        itemType: CONSTANTS.GENNERAL.FIELD_ITEM,
        dataObject: dataObject,
        querySourceField: itemData,
        sourceDataObjectName: dataObject.name
      };
      return item;
    }
  },

  targetOptions: {
    drop(props: any, monitor: any, component: any) {
      if (monitor.didDrop()) {
        return;
      }

      const { reportFilters, reportStore } = props.store;
      const item = monitor.getItem() || {};
      const { changePosition, filterable, querySourceFieldId, sourceDataObjectName, dataObject } = item;

      if (get('querySourceField.isRunningField', item) === true) {
        props.dropMessage(CONSTANTS.BUNDLE.MESSAGE.CANNOT_ADD_RUNNIG_FILTER);
        return;
      }

      if (changePosition) {
        const nextIndex = item.itemDataIndex < position.value ? position.value - 1 : position.value;
        reportFilters.moveTo(item.itemDataIndex, nextIndex);
        return;
      }

      if (!filterable || get('querySourceField.isCompositeField', item)) {
        props.dropMessage(CONSTANTS.BUNDLE.MESSAGE.M02);
        return;
      }

      querySourceFieldId &&
        reportFilters.addFilterById(
          querySourceFieldId,
          sourceDataObjectName,
          {
            relationshipId: dataObject && dataObject.isAlias ? dataObject.id : null
          },
          position.value
        );

      resetStyleItem(component.props.filterFields);

      position.value = null;
      reportStore.model.markDirty();
    },

    canAccess(item: any) {
      item = item || {};
      const { itemType, visible, filterable, isParameter } = item;
      const isRunningField = get('querySourceField.isRunningField', item);
      const isCompositeField = get('querySourceField.isCompositeField', item);
      if (itemType === CONSTANTS.GENNERAL.FIELD_ITEM) {
        return visible && filterable && !isParameter && !isRunningField && !isCompositeField;
      }

      return true;
    },

    canDrop(props: any, monitor: any) {
      const item = monitor.getItem();
      const { itemType, isParameter } = item;

      if (isNil(item)) {
        return false;
      }

      return itemType !== CONSTANTS.GENNERAL.FIELD_ITEM || !isParameter;
    },

    hover(props: any, monitor: any, component: any) {
      hover(props, monitor, component, position);
    }
  }
};



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Izenda.DnDFieldsConfig.js